import { useEffect, useState } from "react";

import Box from "ds/components/Box";
import Button from "ds/components/Button";
import FormField from "ds/components/Form/Field";
import FormFieldHelperText from "ds/components/Form/Field/HelperText";
import Textarea from "ds/components/Textarea";

type PollingFlagProps = {
  finalFlags: Record<string, unknown>;
  modifyFlag: (key: string, value: boolean) => void;
};

const getDefaultValue = (finalFlags: Record<string, unknown>) => {
  try {
    return "frontendPollingSeconds" in finalFlags
      ? JSON.stringify(finalFlags.frontendPollingSeconds)
      : "";
  } catch {
    return "";
  }
};

const PollingFlag = ({ finalFlags, modifyFlag }: PollingFlagProps) => {
  const [frontendPollingSeconds, setFrontendPollingSeconds] = useState<string>(
    getDefaultValue(finalFlags)
  );

  useEffect(() => {
    setFrontendPollingSeconds(getDefaultValue(finalFlags));
  }, [finalFlags]);
  const [error, setError] = useState<string | undefined>(undefined);

  return (
    <Box gap="large" fullWidth>
      <FormField label="Frontend polling seconds" fullWidth noMargin>
        {({ ariaInputProps }) => (
          <>
            <Textarea
              error={!error}
              value={frontendPollingSeconds}
              onChange={(e) => setFrontendPollingSeconds(e.target.value)}
            />
            <FormFieldHelperText id={ariaInputProps.id} error={error} />
          </>
        )}
      </FormField>
      <Box direction="column" justify="center">
        <Button
          variant="secondary"
          onPress={() => {
            try {
              const newValue = JSON.parse(frontendPollingSeconds);
              modifyFlag("frontendPollingSeconds", newValue);
            } catch {
              setError("Cannot parse JSON, use: https://jsonlint.com/");
            }
          }}
        >
          Change
        </Button>
      </Box>
    </Box>
  );
};

export default PollingFlag;
